var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletedFromProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256,490.7C125.9,490.7,21.3,386.1,21.3,256S125.9,21.3,256,21.3S490.7,125.9,490.7,256S386.1,490.7,256,490.7z M256,64 C149.3,64,64,149.3,64,256s85.3,192,192,192s192-85.3,192-192S362.7,64,256,64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M352,373.3c-6.4,0-10.7-2.1-14.9-6.4l-192-192c-8.5-8.5-8.5-21.3,0-29.9c8.5-8.5,21.3-8.5,29.9,0l192,192 c8.5,8.5,8.5,21.3,0,29.9C362.7,371.2,358.4,373.3,352,373.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M373.3,160c0,6.4-2.1,10.7-6.4,14.9l-192,192c-8.5,8.5-21.3,8.5-29.9,0c-8.5-8.5-8.5-21.3,0-29.9l192-192 c8.5-8.5,21.3-8.5,29.9,0C371.2,149.3,373.3,153.6,373.3,160z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedFromProject);
export default __webpack_public_path__ + "static/media/deleted-from-project.6074a18d.svg";
export { ForwardRef as ReactComponent };